<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
          <!-- Introduction Section -->
          <div v-if="showIntroduction" class="introduction-section">
            <img :src="require('@/assets/loanofficercat.png')" alt="Loan Officer" width="200" height="200">
            <h2>Welcome {{ userName }} to your new job as a bank fraud officer!</h2>
            <p>As the newest Fraud Officer at Cat Bank, your job is to evaluate customer knowledge of fraudulent activities and protect them from potential fraud. Your decisions will impact the bank's success and your career. Good luck!</p>
            <button class="option-button" @click="startGame">Start Game</button>
          </div>
  
          <!-- Quiz Section -->
          <div v-else class="quiz-container">
            <h2 class="quiz-title">{{ quizTitle }}</h2>
            <div v-if="currentQuestionIndex < questions.length" class="question-container">
              <p class="question">{{ questions[currentQuestionIndex].description }}</p>
              <div class="options-container">
                <button class="option-button" @click="submitAnswer(true)">Yes</button>
                <button class="option-button" @click="submitAnswer(false)">No</button>
              </div>
            </div>
  
            <!-- Summary Section -->
            <div v-else class="summary-container">
              <h3>Quiz Summary</h3>
              <p>Your score: {{ score }}%</p>
              <p v-if="score >= 70">Congratulations! You've passed.</p>
              <p v-else>Unfortunately, you did not pass. Try again!</p>
              <button @click="restartQuiz" class="restart-quiz-button">Restart Quiz</button>
              <button @click="proceedToNextQuiz" class="next-quiz-button">Next Quiz</button>
            </div>
          </div>
        </div>
      </div>
    </div><br><br><br><br><br><br><br>
  </template>
  
  <script>
  import { ref, computed, onMounted } from 'vue';
  import { Auth } from 'aws-amplify';

  
  export default {
    setup() {
    const showIntroduction = ref(true);
    const userName = ref(''); // Initial empty string for user's name
    const quizTitle = ref("Bank Fraud Officer Awareness Quiz");
    const questions = ref([
        {
          description: "Did you recently attempt to make a transaction exceeding your daily limit?",
          correctAnswer: false,
        },
        {
          description: "Have you provided your online banking password to anyone, including family members?",
          correctAnswer: false,
        },
        {
          description: "Is it common for you to receive transaction alerts for activities you do not recognize?",
          correctAnswer: true,
        },
        {
          description: "Do you recognize all recent login locations reported by your banking app?",
          correctAnswer: false,
        },
        {
          description: "Were you asked to verify your account via email with your full banking credentials?",
          correctAnswer: true,
        },
        {
          description: "Do you initiate transfers to new accounts that you do not own or control?",
          correctAnswer: true,
        },
        {
          description: "Have you clicked on links from emails claiming to be from your bank asking for personal information?",
          correctAnswer: true,
        },
        {
          description: "Do you have security software installed on devices you use for online banking?",
          correctAnswer: false,
        },
        {
          description: "Have you received calls asking to confirm personal banking details for security purposes?",
          correctAnswer: true,
        },
        {
          description: "Is it safe to share your ATM PIN with a bank official over the phone?",
          correctAnswer: false,
        },
      ]);
      const fetchUserName = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        userName.value = user.attributes.name;// Or user.attributes.name if using custom attributes
      } catch (error) {
        console.error('Error fetching user information:', error);
      }
    };
      const currentQuestionIndex = ref(0);
        const correctAnswers = ref(0);

        const startGame = () => {
      showIntroduction.value = false;
    };
  
      const submitAnswer = (answer) => {
        if (answer === questions.value[currentQuestionIndex.value].correctAnswer) {
          correctAnswers.value++;
        }
        currentQuestionIndex.value++;
      };
  
      const restartQuiz = () => {
        currentQuestionIndex.value = 0;
        correctAnswers.value = 0;
      };
  
  
      const score = computed(() => Math.round((correctAnswers.value / questions.value.length) * 100));
  
      onMounted(() => {
      fetchUserName();
    });
      return {
      showIntroduction,
      quizTitle,
      currentQuestionIndex,
      questions,
      score,
      startGame,
      submitAnswer,
      restartQuiz,
      userName,
      
    };
  },
};
</script>
  
  <style scoped>
  .quiz-container {
    background-color: #fff; 
    color: #36454f; /* Dark font color for contrast */
    padding: 20px;
    border-radius: 10px;
    max-width: 600px;
    margin: 20px auto; /* Center container and give some space around */
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Soft shadow for depth */
    text-align: center;
  }
  
  .question-container, .summary-container {
    text-align: center;
  }
  
  .question {
    font-size: 1.25rem; /* Larger font size for readability */
    color: #36454f ;
    margin: 20px 0; /* Space around the question */
    text-align: center;
  }
  
  .options-container {
    display: flex;
    justify-content: center;
    gap: 10px; /* Space between options */
  }
  
  .option-button {
    cursor: pointer;
    background-color: #333;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    transition: background-color 0.3s;
  }
  
  .option-button:hover {
    background-color: #d0ccd3; /* Darker shade on hover */
    transform: translateY(-2px); /* Slight lift effect */
  }
  
  .restart-quiz-button {
    background-color: #36454f; /* Dark background for contrast */
    color: white; /* White text for readability */
    border: none; /* No border for a modern look */
    padding: 10px 20px; /* Padding for size */
    cursor: pointer; /* Cursor to pointer to indicate it's clickable */
    border-radius: 25px; /* Rounded corners for a softer look */
    font-weight: bold; /* Bold text for emphasis */
    transition: background-color 0.3s; /* Smooth transition for hover effects */
    margin-top: 20px; /* Space from the content above */
  }
  
  .restart-quiz-button:hover {
    background-color: #4A148C; /* Lighter purple on hover for visual feedback */
  }

 .next-quiz-button {
  /* Style similar to the restart-quiz-button for consistency */
  background-color: #4A148C; /* Example color */
  color: white;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  border-radius: 25px;
  font-weight: bold;
  margin-top: 10px;
}

.next-quiz-button:hover {
  background-color: #362f78; /* Darker on hover */
}

.wrapper {
    display: flex;
  justify-content: center;
  align-items: center;
}
.intro-image {
  margin-bottom: 20px;
}
.content-container {
background-color: #4A148C ;  /* Light orange color */
text-align: center;
  max-width: 600px;
  width: 100%;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
.stingy-card {
flex: 1;  /* Take up equal width as the iframe */
padding: 20px;
border-radius: 8px;
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
background-color: white
}
  </style>